import { useBoolean } from "@chakra-ui/react";
import VoteIcon from "./VoteIcon";

const ActivityVote = () => {
  const [selected, setSelected] = useBoolean();
  return <VoteIcon selected={selected} onClick={setSelected.toggle} />;
};

export default ActivityVote;
